import LineChartComponent from './LineChart';
import PieChartComponent from './PieChart';

// Default export is LineChartComponent for backward compatibility
const Chart = LineChartComponent;

// Named exports for specific chart types
export { LineChartComponent, PieChartComponent };

export default Chart;
